import { FilterOperatorItem, FilterOperators } from './grid-custom-filter.interface';

export const operatorList: Array<FilterOperatorItem> = [
    { value: FilterOperators.Equal, label: 'isEqualTo' },
    { value: FilterOperators.NotEqual, label: 'isNotEqualTo' },
    { value: FilterOperators.StartsWith, label: 'startsWith' },
    { value: FilterOperators.EndsWith, label: 'endsWith' },
    { value: FilterOperators.IsNull, label: 'isBlank' },
    { value: FilterOperators.IsNotNull, label: 'isNotBlank' },
    { value: FilterOperators.Contains, label: 'contains' },
    { value: FilterOperators.DoesNotContain, label: 'notContains' },
    { value: FilterOperators.GreaterThan, label: 'greaterThan' },
    { value: FilterOperators.GreaterThanEqualTo, label: 'greaterThanOrEqualTo' },
    { value: FilterOperators.LessThan, label: 'lessThan' },
    { value: FilterOperators.LessThanEqualTo, label: 'lessThanOrEqualTo' },
];

export const boolOperators = [
    FilterOperators.Equal,
    FilterOperators.NotEqual,
    FilterOperators.IsNull,
    FilterOperators.IsNotNull,
];

export const containsOperators = [FilterOperators.Contains, FilterOperators.DoesNotContain];

export const stringOperators = [
    FilterOperators.Equal,
    FilterOperators.NotEqual,
    FilterOperators.StartsWith,
    FilterOperators.EndsWith,
    FilterOperators.Contains,
    FilterOperators.DoesNotContain,
    FilterOperators.IsNull,
    FilterOperators.IsNotNull,
];
export const numericAndDateOperators = [
    FilterOperators.Equal,
    FilterOperators.NotEqual,
    FilterOperators.GreaterThan,
    FilterOperators.GreaterThanEqualTo,
    FilterOperators.LessThan,
    FilterOperators.LessThanEqualTo,
    FilterOperators.IsNull,
    FilterOperators.IsNotNull,
];
